import { type SearchRequest } from '@searchkit/api';

import { getMatchupCentreSorting } from '~/apps/product-plus/search-domain/pipelines/match-centre/query-config';
import { createQueryFactory } from '~/apps/product-plus/search-domain/pipelines/match-centre/query-factory';
import { type SearchDomainContext } from '~/apps/product-plus/search-domain/types';
import { normalizeFacetFilters, withRequestParams } from '~/apps/product-plus/search-domain/utils';

export function buildMatchupCentreQuery(context: SearchDomainContext, searchRequest: SearchRequest) {
  if (searchRequest.request?.type === 'facet') {
    return searchRequest;
  }

  const params = searchRequest.request?.params ?? {};
  const facetFilters = normalizeFacetFilters(params.facetFilters);

  const mappedSearchRequest = withRequestParams(searchRequest, {
    facetFilters,
    hitsPerPage: params.hitsPerPage ?? 10,
    page: params.page ?? 0,
  });

  const sorting = getMatchupCentreSorting(context);

  return createQueryFactory({
    searchRequest: mappedSearchRequest,
    sorting,
  });
}
